import { render, staticRenderFns } from "./revenueData.vue?vue&type=template&id=27b81a42&scoped=true&"
import script from "./revenueData.vue?vue&type=script&lang=js&"
export * from "./revenueData.vue?vue&type=script&lang=js&"
import style0 from "./revenueData.vue?vue&type=style&index=0&id=27b81a42&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b81a42",
  null
  
)

export default component.exports